import { render, staticRenderFns } from "./crearEmpresa.view.vue?vue&type=template&id=36f75cf4"
import script from "./crearEmpresa.view.vue?vue&type=script&lang=js"
export * from "./crearEmpresa.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports